import React, { useState, createContext, useContext } from 'react';
import { translations, Lang, Translations } from './translations';
interface LanguageContextValue {
  lang: Lang;
  setLang: (lang: Lang) => void;
  toggle: () => void;
  t: Translations;
}
const LanguageContext = createContext<LanguageContextValue | undefined>(undefined);
export function LanguageProvider({
  children
}: {
  children: ReactNode;
}) {
  const [lang, setLang] = useState<Lang>('es');
  const value: LanguageContextValue = {
    lang,
    setLang,
    toggle: () => setLang(prev => prev === 'es' ? 'en' : 'es'),
    t: translations[lang] as Translations
  };
  return <LanguageContext.Provider value={value} data-id="element-186">
      {children}
    </LanguageContext.Provider>;
}
export function useLanguage() {
  const ctx = useContext(LanguageContext);
  if (!ctx) throw new Error('useLanguage must be used inside LanguageProvider');
  return ctx;
}